import axios from "axios"
import constant from "./constant";
export const useaxios = async (location, datas) => {
    try {
        const tokenString = localStorage.getItem('HomeSmile_Token');
        const token = tokenString ? JSON.parse(tokenString)?.token : null;
        var axiosresult = await (await axios.post(constant.host + location, datas, {
            headers: {
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        }));

        if (axiosresult.status === 200) {
            return axiosresult.data;
        } else {
            return 'request_failed';
        }

    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                return 'Unauthorized';
            }
            return 'request_failed';
        }
        return 'request_failed';
    }
}